import { kitchenImplantationMock } from '@mock/schema/components/shared/kitchen-implantation.mock';
import { Kitchen } from '@shared/models';

export const kitchenMock: Kitchen = {
  id: '7031',
  name: 'INDUS',
  implantation: kitchenImplantationMock,
  price: `4515,00 €`,
  ecoPart: `30,57 €`,
  variants: [
    {
      id: '41673',
      name: 'Mezzo noir mat',
      shortName: 'Noir',
      image: {
        link: 'https://cms-test.socooc.com/sites/socooc/files/modeles/socooc-cuisines-equipees-indus.jpg',
        alt: '',
        gravity: {
          width: 3000,
          height: 2000,
          x: 1500,
          y: 1000,
        },
      },
      colorRgb: '64,65,66',
      fronts: [
        {
          key: '41478',
          label: 'Noir',
        },
      ],
    },
    {
      id: '41676',
      name: 'Mezzo Praliné mat',
      shortName: 'Praliné mat',
      image: {
        link: 'https://cms-test.socooc.com/sites/socooc/files/modeles/socooc-cuisines-equipees-indus-praline.jpg',
        alt: '',
        gravity: {
          width: 1140,
          height: 760,
          x: 570,
          y: 380,
        },
      },
      colorRgb: '202,195,183',
      fronts: [
        {
          key: '41479',
          label: 'Tons clairs',
        },
      ],
    },
    {
      id: '41671',
      name: 'Mezzo moka mat',
      shortName: 'Moka mat',
      image: {
        link: 'https://cms-test.socooc.com/sites/socooc/files/modeles/socooc-cuisines-equipees-indus-moka.jpg',
        alt: '',
        gravity: {
          width: 1140,
          height: 760,
          x: 570,
          y: 380,
        },
      },
      colorRgb: '47,54,60',
      fronts: [
        {
          key: '41480',
          label: 'Tons foncés',
        },
      ],
    },
    {
      id: '41633',
      name: 'Mezzo blanc alaska mat',
      shortName: 'Blanc',
      image: {
        link: 'https://cms-test.socooc.com/sites/socooc/files/modeles/socooc-cuisines-equipees-indus-d%25C3%25A9clinaisons-blanc.jpg',
        alt: '',
        gravity: {
          width: 1500,
          height: 1025,
          x: 750,
          y: 513,
        },
      },
      colorRgb: '237,238,231',
      fronts: [
        {
          key: '41467',
          label: 'Blanc',
        },
      ],
    },
    {
      id: '41631',
      name: 'Mezzo bleu nocturne mat',
      shortName: 'Bleu nocturne',
      image: {
        link: 'https://cms-test.socooc.com/sites/socooc/files/modeles/socooc-cuisines-equipees-indus-d%25C3%25A9clinaisons-bleu_0.jpg',
        alt: '',
        gravity: {
          width: 1500,
          height: 1025,
          x: 750,
          y: 513,
        },
      },
      colorRgb: '47,54,60',
      fronts: [
        {
          key: '41466',
          label: 'Bleu',
        },
      ],
    },
    {
      id: '41665',
      name: 'Mezzo gris clair mat',
      shortName: 'Gris clair',
      image: {
        link: 'https://cms-test.socooc.com/sites/socooc/files/modeles/socooc-cuisines-equipees-indus-gris-clair.jpg',
        alt: '',
        gravity: {
          width: 1140,
          height: 760,
          x: 570,
          y: 380,
        },
      },
      colorRgb: '183,186,183',
      fronts: [
        {
          key: '41477',
          label: 'Gris',
        },
      ],
    },
    {
      id: '41681',
      name: 'Mezzo vert pastel mat',
      shortName: 'Vert pastel',
      image: {
        link: 'https://cms-test.socooc.com/sites/socooc/files/modeles/socooc-cuisines-equipees-indus-vert-pastel.jpg',
        alt: '',
        gravity: {
          width: 1140,
          height: 760,
          x: 570,
          y: 380,
        },
      },
      colorRgb: '141,158,156',
      fronts: [
        {
          key: '41476',
          label: 'Vert',
        },
      ],
    },
    {
      id: '41678',
      name: 'Mezzo rose pastel mat',
      shortName: 'Rose pastel',
      image: {
        link: 'https://cms-test.socooc.com/sites/socooc/files/modeles/socooc-cuisines-equipees-indus-rose-pastel.jpg',
        alt: '',
        gravity: {
          width: 1140,
          height: 760,
          x: 570,
          y: 380,
        },
      },
      colorRgb: '180,149,144',
      fronts: [
        {
          key: '41474',
          label: 'Rose',
        },
      ],
    },
  ],
  url: '/mock-modeles/indus',
};
